import { GlobalController } from 'src/shared/global/GlobalController'
import TechnologyDashboard from './TechnologyDashboard.vue'

const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}

export const routes = [
  {
    path: ':link',
    name: 'technologyDashboard',
    component: TechnologyDashboard,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
